import { drugService } from '../services/drugService'

const atcCache = new Map<string, string[]>()

/**
 * Resolve ATC codes for reference drug IDs (HPRA DrugIDPK). Caches per session.
 */
export async function getAtcCodesForDrugIds(referenceDrugIds: (string | undefined)[]): Promise<Map<string, string[]>> {
  const unique = Array.from(new Set(referenceDrugIds.filter(Boolean))) as string[]
  const result = new Map<string, string[]>()

  await Promise.all(
    unique.map(async (id) => {
      if (atcCache.has(id)) {
        result.set(id, atcCache.get(id)!)
        return
      }
      try {
        const drug = await drugService.getByDrugIdPK(id)
        const atcs = Array.isArray(drug.atcs) ? drug.atcs : []
        atcCache.set(id, atcs)
        result.set(id, atcs)
      } catch {
        atcCache.set(id, [])
        result.set(id, [])
      }
    }),
  )

  return result
}
